import { formatCurrencyInCents } from 'helpers';
import { FieldValues } from 'react-hook-form';
import { number, object, string } from 'yup';

export const reasonOptions = [
    {
        label: 'Erro',
        value: 'BE08',
    },
    {
        label: 'Fraude',
        value: 'FR01',
    },
    {
        label: 'Usuário de origem',
        value: 'MD06',
    },
    {
        label: 'Erro de saque/troco',
        value: 'SL02',
    },
];

const reason = reasonOptions.map((item) => item.value);

export function validationSchemaPixRefund(formValues: FieldValues | undefined) {
    return object().shape({
        reason: string()
            .oneOf(reason, 'Motivo inválido.')
            .typeError('Selecione um motivo.')
            .required('Selecione um motivo.'),
        observation: string().nullable(),
        valueInCents: number()
            .required('Informe o valor a ser estornado.')
            .positive('O valor deve ser maior que zero.')
            .typeError('Informe um valor válido.')
            .test(
                'validate',
                `O valor não pode ultrapassar o valor da transferência original de R$ ${formatCurrencyInCents(formValues?.amount)}`,
                (value) => {
                    if (formValues?.amount) {
                        return (value ?? 0) <= formValues.amount;
                    }
                    return true;
                }
            )
    });
}

export function defaultValuesPixRefund(formValues: FieldValues | undefined) {
    return {
        reason: null,
        observation: null,
        valueInCents: formValues?.amount
    };
}
